<template>
  <div id="gallery">
    <carousel autoplay :scrollPerPage="false" :autoplayTimeout="5000" :loop="true" autoplayHoverPause paginationActiveColor="#FFF" paginationColor="rgba(255, 255, 255, .38)">
      <slide v-for="(image, key) in gallery" :key="key">
        <div class="image">
          <img :src="require(`../assets/gallery-2019/${image}`)" alt="gallery image">
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
  
  import {Carousel, Slide} from 'vue-carousel';

  export default {
    components: {
      Carousel,
      Slide,
    },
    data () {
      return {
        galleryLength: 29,
      }
    },
    computed: {
      gallery() {
        const images = [];
        for (let i = 1; i <= this.galleryLength; ++i) {
          images.push(`${i}.jpg`);
        }
        return images;
      }
    },
  }

</script>

<style lang="scss">
  
  #gallery {
    padding: 40px 0;
    background: url('../assets/pattern.png');

    .image {
      margin: 0 24px;
      img {
        height: 100%;
        max-height: 500px;
      }
    }

    @media screen and (max-width: 900px) {
      .image {
        height: 200px;
      }
    }
  }

</style>